import {FC, useState} from 'react';
import {Box, Button, Flex, Grid} from '@chakra-ui/react';
import {Dialog, ISelectOption, Select} from '@progress-fe/ui-kit';
import {useT} from '@progress-fe/core';
import {IJournalPoint} from 'core/interfaces';
import {EDumpReasonType} from 'core/enums';

interface IProps {
  point: IJournalPoint;
  onCreate: (calcNumber: number, reason: EDumpReasonType) => Promise<void>;
  onClose: () => void;
}

const CreateCheckpointDialogFC: FC<IProps> = ({point, onCreate, onClose}) => {
  const [createReason, setCreateReason] = useState<EDumpReasonType>(EDumpReasonType.BeforeRun);

  const {t} = useT();

  const handleCreate = async () => {
    await onCreate(point.calculationNumber, createReason);
    onClose();
  };

  const options: Array<ISelectOption<EDumpReasonType>> = [
    {
      label: t(`enum.dumpReasonType.${EDumpReasonType.BeforeRun}`),
      value: EDumpReasonType.BeforeRun
    },
    {
      label: t(`enum.dumpReasonType.${EDumpReasonType.AfterRun}`),
      value: EDumpReasonType.AfterRun
    }
  ];

  return (
    <Dialog title={t('checkpoints.create')} onClose={onClose}>
      <Box w={'250px'}>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Box pt={'10px'}>{t('checkpoints.usePoint', {name: point.calculationNumber})}:</Box>
          <Box pb={'10px'}>
            <Select
              options={options}
              name={t('checkpoints.create')}
              placeholder={t('common.notSelected')}
              value={options.find((opt) => opt.value === createReason)}
              onChange={(newValue) => {
                setCreateReason((newValue as ISelectOption<EDumpReasonType>).value);
              }}
            />
          </Box>

          <Grid p={'8px 0'} gridTemplateColumns={'1fr 1fr'} gap={'8px'}>
            <Button w={'100%'} size={'xs'} variant={'ghost'} onClick={onClose}>
              {t('actions.cancel')}
            </Button>
            <Button w={'100%'} size={'xs'} variant={'solid'} onClick={handleCreate}>
              {t('actions.create')}
            </Button>
          </Grid>
        </Flex>
      </Box>
    </Dialog>
  );
};

export const CreateCheckpointDialog = CreateCheckpointDialogFC;
